import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from '@/App.vue';
import { router } from '@/router';
import { useAuthStore } from '@/stores/auth';

import '@/assets/main.css';

async function bootstrap(): Promise<void> {
    const app = createApp(App);
    app.use(createPinia());

    // Try to hydrate the current user before mounting so the initial route
    // resolution sees the correct auth state. A 401 here just means the user
    // isn't logged in and the router will send them to /login.
    const auth = useAuthStore();
    try {
        await auth.fetchUser();
    } catch {
        // intentionally swallow — anonymous boot is expected
    }

    app.use(router);
    app.mount('#app');
}

void bootstrap();
